import { getMeetingURL } from '../components/elements/Meeting/getMeetingURL';
import notificationTypes from '../data/constants/notificationTypes';
import { getTargetURL } from './getTargetURL';

export default function notificationTargetURL(notificationData) {
    switch (notificationData.type) {
        case notificationTypes.MEETING_INVITE:
        case notificationTypes.MEETING_CONFIRM_OR_REJECT:
            // return ['/events', notificationData.eventId, 'meetings', '-', notificationData.meetingId].join('/');
            return getMeetingURL(notificationData.eventId, notificationData.meetingId);
            break;
        case notificationTypes.NEW_QUESTION_ANSWER:
        case notificationTypes.NEW_ANSWER:
            return ['/events', notificationData.eventId, 'qa', 'all', 'question', notificationData.questionId].join('/');
            break;
        case notificationTypes.CHAT_QUESTION:
        case notificationTypes.NEW_CHAT_MESSAGE:
            return ['/events', notificationData.eventId, 'chats', notificationData.chatId].join('/');
            break;
        case notificationTypes.TASK_UPDATE:
            return ['/events', notificationData.eventId, 'schedule'].join('/');
            break;
        case notificationTypes.EVENT_MESSAGE:
            {
                let target = notificationData.target;
                if (target) {
                    return getTargetURL(notificationData.eventId, target);
                } else {
                    return ['/events', notificationData.eventId, 'news', notificationData.newsId].join('/');
                }
            }
            break;
        case notificationTypes.EVENT_ADDED:
        case notificationTypes.SILENT_UPDATE:
        default:
            throw new Error('Unknown notification type');
    }
}
